<template>
  <div class="tcla-orphans">
    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🏝️ صفحات یتیم (بدون لینک ورودی)</h3>
      <div v-if="orphans.length === 0" class="tcla-empty">🎉 هیچ صفحه یتیمی نیست</div>
      <div v-for="o in orphans" :key="o.url" class="tcla-orphan-card tcla-issue--err">
        <div class="tcla-orphan-card__head">
          <strong>{{ o.title }}</strong>
          <button class="tcla-btn" @click="$emit('edit-blog', o.source)">ویرایش</button>
        </div>
        <div class="tcla-orphan-card__meta">
          هیچ لینک ورودی داخلی ندارد · اقتدار: {{ o.authority }}
        </div>
      </div>
    </div>

    <div class="tcla-panel">
      <h3 class="tcla-panel__title">🚧 صفحات بن‌بست (بدون لینک خروجی)</h3>
      <div v-if="deadEnds.length === 0" class="tcla-empty">🎉 هیچ صفحه بن‌بستی نیست</div>
      <div v-for="d in deadEnds" :key="d.url" class="tcla-deadend-card tcla-issue--warn">
        <div class="tcla-deadend-card__head">
          <strong>{{ d.title }}</strong>
          <button class="tcla-btn" @click="$emit('edit-blog', d.source)">ویرایش</button>
        </div>
        <div class="tcla-deadend-card__meta">
          بدون لینک خروجی · لینک ورودی: {{ d.incomingCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TCLAOrphans',
  props: {
    orphans: { type: Array, default: () => [] },
    deadEnds: { type: Array, default: () => [] }
  }
};
</script>

<style scoped>
.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
  margin-bottom: 16px;
}

.tcla-panel__title { font-size: 0.95rem; font-weight: 700; margin: 0 0 14px 0; }
.tcla-empty { text-align: center; padding: 20px; color: #9ca3af; }

.tcla-orphan-card, .tcla-deadend-card {
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 14px;
  margin-bottom: 12px;
}

.tcla-orphan-card, .tcla-issue--err { background: #fee2e2; border-color: #fecaca; }
.tcla-deadend-card, .tcla-issue--warn { background: #fef3c7; border-color: #fcd34d; }

.tcla-orphan-card__head, .tcla-deadend-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.tcla-orphan-card__meta, .tcla-deadend-card__meta {
  font-size: 0.8rem;
  margin-bottom: 4px;
}

.tcla-btn {
  padding: 6px 12px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s;
}
.tcla-btn:hover { background: #e5e7eb; }
</style>
